angular.module('bribac.services.routeAuth', [
  'bribac.services.authStorage',
  'bribac.services.api',
  'bribac.entities.kinds'
])

  .factory('routeAuth', function(
    $q,
    authStorage,
    api,
    KINDS
  ) {
    var routeAuth =  {
      OK: 'OK',
      AUTHORIZED: 'AUTHORIZED',
      UNAUTHORIZED: 'UNAUTHORIZED',
      FORBIDDEN: 'FORBIDDEN',

      requireAuth: function() {
        if (authStorage.getTab()) {
          return routeAuth.OK
        } else {
          // When we return this promise we will pause the router until the
          // promise has resolved, so we can restore the session if there is one
          // before we check route permissions.
          return api.restoreSession().catch(function() {
            // Fail the route auth check if we can't restore the session.
            return $q.reject(routeAuth.UNAUTHORIZED)
          })
        }
      },

      requireUnauth: function() {
        return !authStorage.getTab() ? routeAuth.OK : $q.reject(routeAuth.AUTHORIZED)
      },

      kindMustBeListable: function(kind) {
        return KINDS.mayBeListed.indexOf(kind) > -1 ? routeAuth.OK : $q.reject(routeAuth.FORBIDDEN)
      }
    }

    return routeAuth
  })
